import { type VifRulesFamilyViewProps, VifRulesShell } from './VifRulesShell';
import { mulDivVariantConfig } from './core/rulesMulDivConfig';
import { RULES_MUL_DIV_COPY } from './core/rulesMulDivCopy';
import type { RulesMulDivFlag } from './core/rulesMulDivProblems';
import { RULES_GRID } from './core/rulesVariantConfig';
import { useMulDivGame } from './hooks/useMulDivGame';
import { useVifRulesModule } from './hooks/useVifRulesModule';

export interface VifMulDivRulesViewProps extends VifRulesFamilyViewProps {
  flag: RulesMulDivFlag;
}

/**
 * DOM implementation of the 3x3 VIF multiplication/division rules board.
 *
 * The add/sub board's twin: both hand `useVifRulesModule` and `VifRulesShell`
 * their family's config, copy and problem selection and keep nothing else. See
 * `VifAddSubRulesView.tsx` for the shared design notes (why round/game are
 * server-owned rather than counted locally).
 *
 * Covers all sixteen `VIFRulesMulDiv` flags, including 6/7/8 ("Auditory
 * Memory").
 */
export function VifMulDivRulesView({
  hubUrl,
  ...options
}: VifMulDivRulesViewProps) {
  const rules = useVifRulesModule({
    ...options,
    grid: RULES_GRID,
    resolveConfig: mulDivVariantConfig,
    useGame: useMulDivGame,
  });

  return (
    <VifRulesShell
      rules={rules}
      copy={RULES_MUL_DIV_COPY[options.flag]}
      hubUrl={hubUrl}
    />
  );
}
